import { render } from "./404.vue?vue&type=template&id=302f51d3&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=302f51d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302f51d3"]])

export default __exports__